<template>
  <base-input :model-value="props.tel" class="col-12 col-md-6" label="電話番号" placeholder="半角数字ハイフンあり"
              :rules="telRules"
              type="text" required-tag @update:model-value="emit('update:tel', $event)"/>
</template>
<script setup lang="ts">
import {useValidator} from "@/composable/ui/useValidator";
import {computed, defineEmits} from "vue";
import BaseInput from "@/components/Forms/BaseInput.vue";
import {ValidatorRule} from "@/composable/ui/useForm";

const props = defineProps({
  tel: String,
  rules: {
    type: Array as () => ValidatorRule<string>[],
    required: false,
  }
});

const emit = defineEmits(['update:tel']);
const {rules} = useValidator();

const telRules = computed(() =>
  props.rules ? props.rules : [rules.requiredWithLabelName({name: '電話番号'}), rules.isPhone()]
);

</script>
<style scoped>
</style>
